import React from "react";

interface BankIconProps {
  className?: string;
  pathClassName?: string;
  fillClassName?: string;
}

const BankIcon: React.FC<BankIconProps> = ({
  className,
  pathClassName,
  fillClassName,
}) => (
  <svg
    width="51"
    height="47"
    viewBox="0 0 51 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M1.74805 16.9799L25.2322 2.32812L48.7164 16.9799"
      stroke="#343962"
      strokeWidth="2.76477"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={pathClassName}
    />
    <path
      d="M6.9668 44.9521H43.4977H6.9668Z"
      fill="#FF4E17"
      className={fillClassName}
    />
    <path
      d="M6.9668 44.9521H43.4977"
      stroke="#343962"
      strokeWidth="2.76477"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={pathClassName}
    />
    <path
      d="M20.0137 15.6484H30.4511H20.0137Z"
      fill="#FF4E17"
      className={fillClassName}
    />
    <path
      d="M20.0137 15.6484H30.4511"
      stroke="#FF4E17"
      strokeWidth="2.76477"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={pathClassName}
    />
    <path
      d="M9.57617 36.9595V23.6396V36.9595Z"
      fill="#FF4E17"
      className={fillClassName}
    />
    <path
      d="M9.57617 36.9595V23.6396"
      stroke="#343962"
      strokeWidth="2.76477"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={pathClassName}
    />
    <path
      d="M20.0137 36.9595V23.6396V36.9595Z"
      fill="#FF4E17"
      className={fillClassName}
    />
    <path
      d="M20.0137 36.9595V23.6396"
      stroke="#343962"
      strokeWidth="2.76477"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={pathClassName}
    />
    <path
      d="M30.4512 36.9595V23.6396V36.9595Z"
      fill="#FF4E17"
      className={fillClassName}
    />
    <path
      d="M30.4512 36.9595V23.6396"
      stroke="#343962"
      strokeWidth="2.76477"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={pathClassName}
    />
    <path
      d="M40.8887 36.9595V23.6396V36.9595Z"
      fill="#FF4E17"
      className={fillClassName}
    />
    <path
      d="M40.8887 36.9595V23.6396"
      stroke="#343962"
      strokeWidth="2.76477"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={pathClassName}
    />
  </svg>
);

export default BankIcon;
